import { Button, Grid, GridColumn, Notice, Separator, TButtonType, TGridColumnWidth, Text } from 'telia-front-react';
import { observer } from 'mobx-react';
import * as React from 'react';
import { AuthService } from '../../CommonInterfaces';
import { runInTeliaRumService } from '../../util/TeliaOtelUtil';
import useStores from '../../stores/UseStores';
import { isSmallModuleView } from '../../util/ModuleUtil';
import RememberMe from '../RememberMe';

interface Bank {
  name: string;
  type: TButtonType;
  authService: AuthService;
}

const BANKS: Bank[] = [
  { name: 'Swedbank', type: 'outer-swed', authService: AuthService.SWED },
  { name: 'SEB', type: 'outer-seb', authService: AuthService.SEB },
  { name: 'LHV', type: 'outer-lhv', authService: AuthService.LHV },
  { name: 'Coop Pank', type: 'outer-coop', authService: AuthService.COOP },
  { name: 'Luminor', type: 'outer-luminor', authService: AuthService.NORDEA },
];

const BanksLogin = observer((): React.JSX.Element => {
  const {
    banksLoginStore,
    translateStore: { translate },
    uiStore: { componentWidth },
  } = useStores();
  const gridWidth: TGridColumnWidth[] = isSmallModuleView(componentWidth) ? ['sm-8', 'md-6', 'lg-12'] : ['xs-12', 'sm-9', 'lg-7', 'xl-8'];

  const renderBankButton = (bank: Bank, index: number, componentWidth: number) => {
    const gridWidth: TGridColumnWidth[] = ['xs-12', 'sm-6', `md-${isSmallModuleView(componentWidth) ? '12' : '4'}`];
    return (
      <GridColumn width={gridWidth} key={index}>
        <Button text={bank.name} type={bank.type} block={true} onClick={() => login(bank)} />
      </GridColumn>
    );
  };

  const login = (bank: Bank) => {
    runInTeliaRumService(`Autentimise algatamine (${bank.name})`, () => {
      banksLoginStore.handleBankClick(bank.authService);
    });
  };

  return (
    <Text>
      {banksLoginStore.error && (
        <Notice>
          <p>
            <strong>{translate(banksLoginStore.errorCode)}</strong>
          </p>
        </Notice>
      )}
      <Grid align={['center-sm']}>
        <GridColumn width={gridWidth}>
          <RememberMe tabItemId="banksLoginTab" />
          <Separator color={'invisible'} spacing={'xxsmall'} />
          <Grid gutter="small">{BANKS.map((bank, index) => renderBankButton(bank, index, componentWidth))}</Grid>
        </GridColumn>
      </Grid>
    </Text>
  );
});

export default BanksLogin;
